import styled, { css } from 'styled-components';

import {
    Col,
} from '@zillow/zrs-comet';

// constellation
import {
    Heading,
    mediaMixin,
    spaceMixin
} from '@zillow/constellation';

export const StyledHeadingWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 20px;
`;

export const StyledHeading = styled(Heading)`
    font-size: 20px;
`;

export const StyledInquiriesCol = styled(Col)`
    ${mediaMixin('lg', css`
        && {
            /* The Col component sets padding-left, padding-right with !important; */
            /* it is nesessary to include !important here and wrap in double && for specificity */
            padding-right: ${spaceMixin('sm')} !important;
        }
    `)}
`;

export const StyledCol = styled(Col)`
    ${mediaMixin('lg', css`
        padding-left: 32px;
    `)}
`;
